import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { CoreIcons } from 'components'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import * as S from './styles'

interface CancelSuccessModalProps {
  onClose: () => void;
  patientName: string;
  appointmentDate: string;
  appointmentTime: string;
  onCreateUnavailability?: () => void;
}

export function CancelSuccessModal({
  onClose,
  patientName,
  appointmentDate,
  appointmentTime,
  onCreateUnavailability,
}: CancelSuccessModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <>
          <S.SuccessIcon>
            <CoreIcons name="Check" fill="#4AC326" width="48" height="48" />
          </S.SuccessIcon>
          <Typography center weight="bold">
            Consulta cancelada
          </Typography>
        </>
      }
      modalSubtitle={
        <S.SubTitleContent>
          <Typography variant="content2" center>
            Paciente <strong>{patientName}</strong>
          </Typography>
          <Typography variant="content2" center weight="bold">
            {appointmentDate}, às {appointmentTime}
          </Typography>
        </S.SubTitleContent>
      }
      btnText="FECHAR"
      btnOnClick={onClose}
      hasButton
      hasCloseButton
    >
      <S.ModalContent>
        <S.Message>
          <Typography variant="content2">
            O horário foi liberado e já está disponível para outros pacientes
            agendarem.
          </Typography>
        </S.Message>

        <S.AdviceBox>
          <Typography variant="content2">
            Caso não queira receber agendamento no(s) dia(s) e horário(s) acima,
            você deve{' '}
            <S.UnavailabilityLink onClick={onCreateUnavailability}>
              criar uma indisponibilidade
            </S.UnavailabilityLink>
            .
          </Typography>
        </S.AdviceBox>
      </S.ModalContent>
    </ModalGeneric>
  )
}
